import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { BigBlindIcon, DealerIcon, SmallBlindIcon } from "@/components/Icons";
import { PlayerAvatar, PlayerCard, PlayerCardInfoWrapper, PlayerCardWrapper, PlayerName, PlayerStatus } from "./PlayerRoles.style";
var PlayerRoles = function (_a) {
    var findPlayer = _a.findPlayer;
    var t = useTranslation().t;
    var playerRoles = [
        { icon: _jsx(DealerIcon, {}), status: "Dealer", role: "dealerIndex" },
        { icon: _jsx(SmallBlindIcon, {}), status: "Small Blind", role: "smallBlindIndex" },
        { icon: _jsx(BigBlindIcon, {}), status: "Big Blind", role: "bigBlindIndex" },
    ];
    var renderPlayerCard = useCallback(function (_a) {
        var icon = _a.icon, status = _a.status, role = _a.role;
        return (_jsxs(PlayerCard, { children: [_jsx(PlayerAvatar, { children: icon }), _jsxs(PlayerCardInfoWrapper, { children: [_jsx(PlayerStatus, { children: t("tableManagement.moreInfoDrawer.onlineTableView.".concat(role)) }), _jsx(PlayerName, { children: findPlayer(role) })] })] }, role));
    }, [findPlayer, t]);
    return _jsx(PlayerCardWrapper, { children: playerRoles.map(renderPlayerCard) });
};
export default PlayerRoles;
